/**
 * Checks a social handle someone typed. Used by the signup form and the profile editor to show
 * a message, and by the server so a bad value never reaches the enrichment queue.
 *
 * Tolerant on purpose: surrounding spaces and a leading @ are fine (they get cleaned up), and a
 * pasted link is left to the link checks. Only a value that cannot be one username is refused,
 * such as two accounts in one field ("name1 & name2").
 */

const SPACES = "Handles can't have spaces. Enter just one username."
const CHARACTERS = 'Usernames use only letters, numbers, periods, underscores and hyphens.'
const LINK_NEEDS_SCHEME = 'Enter just your username, or the full link starting with https://'

/** A message saying what is wrong with the handle, or null when it is fine (or empty). */
export function checkSocialHandle(value: unknown): string | null {
  const raw = String(value ?? '').trim()
  if (!raw) return null
  // Links are checked elsewhere (does it point at the right platform)
  if (/^https?:\/\//i.test(raw)) return null

  const handle = raw.replace(/^@/, '')
  if (/\s/.test(handle)) return SPACES
  if (handle.includes('/')) return LINK_NEEDS_SCHEME
  // Letters from any alphabet are allowed, since YouTube handles can use them
  if (!/^[\p{L}\p{N}._-]+$/u.test(handle)) return CHARACTERS
  return null
}
